export interface LineItemMetadata {
	uniqueShortName?: string;
	keyPhrases?: string;
	explanation?: string;
	units?: string;
	defaultQuantity?: string;
}

export const elementsToRemoveIfExist = ["av", "av+", "av++", "av+++", "av-"];

export const ACTION_VARIABLE_VALUES = ["remove", "remove and replace", "replace", "detach and reset", "install only", "material only", "reset"];

// Recognized as action variables for validation/masking, but intentionally NOT
// auto-populated by populateStringWithExistingElemens.
export const NON_AUTO_POPULATED_ACTION_VARIABLE_VALUES = ["reset"];


export interface AcceptableValueDependency {
	elementIndex: number;
	parentValues: string[];
}

export interface LineItemElementProps {
	value: string;
	type: "text" | "variable";
	acceptableValues?: string[];
	allowEmptyValue?: boolean;
	conditional?: boolean;
	defaultValue?: string;
	valueDependencies?: {
		[value: string]: AcceptableValueDependency[];
	};
}

export interface LineItemVariable extends LineItemElementProps {
	acceptableValues: string[]; // make non optional
}

export interface IDatabaseLineItem {
	category?: string;
	elements: LineItemElementProps[];
	originalLineItem: string;
	id: string;
	deleted?: boolean;
	deletedBy?: string;
	deletedTimestamp?: number;
	lastModifiedBy?: string;
	lastModifiedAt?: number;
	index?: number;
	// constantIndex?: number;
	createTime?: number;
	scopes?: string[];
	metadata?: LineItemMetadata;
}

export interface IOnElementValueClickCBData {
	element: LineItemElementProps;
	value: string;
	elementIndex: number;
	valueIndex: number;
}
